// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6112d980","453":"5fbe1e47","455":"1a5fcdaf","977":"d19a41ed"}[chunkId] + ".chunk.js";
};